import React, { FunctionComponent, ReactElement } from 'react'
import Grid from '@sport1/react-elements/Grid'
import Sport1Logo from '../../Theme/Logos/Sport1'
import ESports1Logo from '../../Theme/Logos/eSports1'
import { ChannelLogoTypes } from '../../Theme/Logos/LogoInterfaces'

export type SplashScreenBackgroundImageProps = { logoType?: Omit<ChannelLogoTypes, 'sport1plus'> }

const SplashScreenBackgroundImage: FunctionComponent<SplashScreenBackgroundImageProps> = ({
    logoType = 'sport1',
}): ReactElement => {
    let logo = <Sport1Logo width={200} type="OnDark" />

    if (logoType === 'esports1') {
        logo = <ESports1Logo width={277} type="OnDark" />
    }

    return (
        <Grid backgroundColor="BLACK" centerHorizontal centerVertical paddingBottom={200}>
            {logo}
        </Grid>
    )
}

export default SplashScreenBackgroundImage
